var React = require('react');

function Bg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M0 0h640v160H0z","key":0}),React.createElement("path",{"fill":"#00966e","d":"M0 160h640v160H0z","key":1}),React.createElement("path",{"fill":"#d62612","d":"M0 320h640v160H0z","key":2})]);
}

Bg.defaultProps = {"id":"flag-icons-bg","viewBox":"0 0 640 480"};

module.exports = Bg;

Bg.default = Bg;
